import React, {Component} from 'react';
import {
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    Row,
    Col,
    Button,
    UncontrolledTooltip,
    CardSubtitle,
} from "reactstrap";
import ReactTable from "react-table";
import classNames from "classnames";
import {connect} from 'react-redux';
import {get} from 'lodash';
import './redux/barcodeSequenza.reducer';
import BarcodeSequenzaCreateComponent from "./components/barcodeSequenza.create.component";
import Fade from "react-reveal/Fade";
import ReactBSAlert from "react-bootstrap-sweetalert";
import _ from 'lodash';
import {readedAll, requestDelete, deleted, deleteError} from "./redux/barcodeSequenza.actions";
import GraphqlClient from "../../client/graphql.client";
import store from "../../store/store";
import {CSVDownload} from "react-csv";
import moment from "moment";


let csvData = [
    ['BARCODE', 'UTENTE'],
];

class barcodeSequenzaComponent extends Component {

    state = {
        data: [],
        loading: false,
        showDeleteAlert: false,
        showEliminaSequenza: false,
        selectedRecordForDelete: {},
        downloadCsv: false,
    }

    caricaDati = async () => {
        try {
            const response = await GraphqlClient.elencoBarcodeSequenza(

            );
            store.dispatch(readedAll(response.elencoBarcodeSequenza)); // scommentare per abilitare redux: al posto di res.getDpiArticles mettere l'oggetto con i dati
        } catch (e) {
            console.log('Impossibile caricare i dati', e);
        }
    }


    componentDidMount() {
        this.caricaDati();
    }


    toggleShowCreateModal = () => {
        this.setState({
            showCreateModal: !this.state.showCreateModal
        })
    }


    toggleDownloadCsv = () => {

        const records = this.selectTable.getResolvedState().sortedData;

        records.forEach((v) => {
            csvData.push([v.barcode, v.utente])
        })

        const callBack = () => {
            this.setState({downloadCsv: false})
        }

        this.setState({downloadCsv: true}, callBack)
    }


    elimina = async () => {
        try {
            this.toggleDeleteAlert(this.state.selectedRecordForDelete);
            store.dispatch(requestDelete(this.state.selectedRecordForDelete.id))
            await GraphqlClient.eliminaBarcodeSequenza({id: this.state.selectedRecordForDelete.id});
            store.dispatch(deleted({id: this.state.selectedRecordForDelete.id})); // scommentare per abilitare redux: al posto di res.getDpiArticles mettere l'oggetto con i dati
        } catch (e) {
            console.log('Impossibile eliminare il record', e);
            store.dispatch(deleteError(this.state.selectedRecordForDelete.id));
        }
    }

    eliminaSequenza = async () => {
        try {
            store.dispatch(requestDelete(this.state.data))
            await GraphqlClient.eliminaSequenza();
            store.dispatch(deleted({id: this.state.data})); // scommentare per abilitare redux: al posto di res.getDpiArticles mettere l'oggetto con i dati
        } catch (e) {
            console.log('Impossibile eliminare il record', e);
            store.dispatch(deleteError(this.state.selectedRecordForDelete.id));
        } finally {
            this.toggleEliminaSequenza()
            this.caricaDati()
        }
    }

    toggleDeleteAlert = (record) => this.setState({
        showDeleteAlert: !this.state.showDeleteAlert,
        selectedRecordForDelete: record
    });

    toggleEliminaSequenza = () => {
        this.setState({
            showEliminaSequenza: !this.state.showEliminaSequenza,
        })
    }


    actions = (cellInfo) => (
        <div className="actions-right">
            {
                get(cellInfo, "original._deleting", false) ? <i className="fa fa-spin fa-spinner"/> : null
            }
            <Button
                color="danger"
                size="sm"
                onClick={() => this.toggleDeleteAlert(cellInfo.original)}
                className={classNames("btn-icon btn-link like")}
            >
                <i className="tim-icons icon-simple-remove"/>
            </Button>{" "}
        </div>
    );

    render() {
        return (
            <>

                {
                    this.state.showDeleteAlert ?
                        <ReactBSAlert
                            warning
                            style={{display: "block"}}
                            title="Confermare l'eliminazione ?"
                            onConfirm={() => this.elimina()}
                            onCancel={() => this.toggleDeleteAlert()}
                            confirmBtnBsStyle="success"
                            cancelBtnBsStyle="danger"
                            confirmBtnText="Si"
                            cancelBtnText="No"
                            showCancel
                            btnSize=""
                        >
                            Stai per eliminare in modo
                            definitivo: {this.state.selectedRecordForDelete?.barcode}
                        </ReactBSAlert> : null
                }
                {
                    this.state.showEliminaSequenza ?
                        <ReactBSAlert
                            warning
                            style={{display: "block"}}
                            title="Confermare l'eliminazione ?"
                            onConfirm={() => this.eliminaSequenza()}
                            onCancel={() => this.toggleEliminaSequenza()}
                            confirmBtnBsStyle="success"
                            cancelBtnBsStyle="danger"
                            confirmBtnText="Si"
                            cancelBtnText="No"
                            showCancel
                            btnSize=""
                        >
                            Stai per eliminare L'INTERA SEQUENZA !!!
                        </ReactBSAlert> : null
                }
                <BarcodeSequenzaCreateComponent show={this.state.showCreateModal} toggle={this.toggleShowCreateModal}/>


                {/*Contenuto pagina*/}
                <div className="content">
                    <Row>
                        <Col xs={12} md={12}>
                            <Card>
                                <CardBody>
                                    {/*Filtri*/}
                                    <Row>

                                        <Col className="mr-auto">
                                            <button className="btn btn-primary " id="nuovoModal"
                                                    onClick={() => this.toggleShowCreateModal()}><i
                                                className="tim-icons icon-simple-add"/>Nuovo
                                            </button>
                                            <UncontrolledTooltip placement="bottom" target="nuovoModal" delay={0}>
                                                Crea un nuovo lotto<br/> ( Hotkey F11)
                                            </UncontrolledTooltip>
                                        </Col>
                                        <Col className="d-flex justify-content-end">

                                            <Button className="btn btn-primary"
                                                    onClick={this.toggleEliminaSequenza}>
                                                Elimina sequenza
                                            </Button>

                                            <Button className="btn btn-primary" onClick={this.toggleDownloadCsv}>
                                                {this.state.downloadCsv ? <CSVDownload data={csvData}
                                                                                       target="_blank"/> : "Tracciato CSV"}
                                            </Button>


                                            <button id="refresh" onClick={() => {
                                                this.caricaDati(this.state.startDate, this.state.endDate, this.state.fullText);
                                            }} className="btn btn-primary btn-fab btn-icon ">
                                                <i className="tim-icons icon-refresh-01"></i>
                                            </button>
                                            <UncontrolledTooltip placement="bottom" target="refresh" delay={0}>
                                                Ricarica i dati
                                            </UncontrolledTooltip>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>

                        <Col xs={12} md={12}>
                            <Card>
                                <CardHeader>
                                    <CardTitle tag="h4">Sequenza scansionata</CardTitle>
                                    <Fade when={this.props.loading}>
                                        <CardSubtitle>Caricamento in corso <i
                                            className="fa fa-spin fa-spinner"/></CardSubtitle>
                                    </Fade>
                                </CardHeader>
                                <CardBody>
                                    <ReactTable
                                        ref={(r) => {
                                            this.selectTable = r;
                                        }}

                                        data={this.props.data}
                                        filterable
                                        resizable={false}
                                        columns={[

                                            {
                                                Header: "data",
                                                accessor: "dataMovimento",
                                                Cell: row => {
                                                    if (!row.value) return "-";
                                                    return <div>{moment.unix(row.value).format("DD/MM/YYYY hh:mm")}</div>
                                                },
                                                width: 150,

                                            },
                                            {
                                                Header: "utente",
                                                accessor: "utente"
                                            },
                                            {
                                                Header: "barcode",
                                                accessor: "barcode"
                                            },

                                            {
                                                Header: "Azioni",
                                                Cell: this.actions,
                                                sortable: false,
                                                filterable: false,
                                                show: !this.props.readOnly,
                                            }]
                                        }
                                        defaultPageSize={10}
                                        showPaginationBottom={true}
                                        className="-striped -highlight"
                                        nextText={'Avanti'}
                                        previousText={'Indietro'}
                                        pageText={'Pagina'}
                                        ofText={'di'}
                                        rowsText={'elementi'}
                                        noDataText={'Nessun dato'}
                                        loadingText={'Caricamento in corso'}
                                        loading={false}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    const data = {
        data: get(state, "barcodeSequenza.data", []),
        loading: get(state, "barcodeSequenza.loading", false)
    };

    if (data.data === null) data.data = [];


    return data;
};


export default connect(mapStateToProps, () => ({}))(barcodeSequenzaComponent)
